var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeridaptMilestoneFlagBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 6.20898C7.33301 5.6567 6.88529 5.20898 6.33301 5.20898C5.78072 5.20898 5.33301 5.6567 5.33301 6.20898V25.5423C5.33301 26.0946 5.78072 26.5423 6.33301 26.5423C6.88529 26.5423 7.33301 26.0946 7.33301 25.5423V19.687L9.5429 19.2218C11.4724 18.8156 13.483 19.0849 15.2376 19.9847C17.696 21.2455 20.5496 21.4963 23.1903 20.6838L25.9604 19.8314C26.38 19.7023 26.6663 19.3147 26.6663 18.8756V7.54231C26.6663 7.24095 26.5304 6.95566 26.2964 6.76578C26.0624 6.5759 25.7552 6.50168 25.4603 6.56376L22.2873 7.23177C20.4198 7.62492 18.4777 7.4565 16.7058 6.74773L16.0363 6.47995C13.8978 5.62453 11.5539 5.42126 9.3 5.89576L7.33301 6.30987V6.20898Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeridaptMilestoneFlagBig);
export default __webpack_public_path__ + "static/media/veridapt-milestone-flag-big.3b510405785e06a9ac5c022ffe9e81c1.svg";
export { ForwardRef as ReactComponent };